import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card } from '../../components/ui/Card'
import { 
  CategoriesIcon, 
  CertifIcon, 
  BrandIcon, 
  ContinentsIcon, 
  MessageIcon 
} from '../../components/icons'

interface SettingItemProps {
  icon: React.ReactNode
  title: string
  subtitle: string
  onClick: () => void
}

const SettingItem: React.FC<SettingItemProps> = ({ icon, title, subtitle, onClick }) => {
  return (
    <div
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      className="flex items-center p-4 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer rounded-lg transition-colors"
      role="button"
      tabIndex={0}
      aria-label={`${title}: ${subtitle}`}
    >
      <div className="w-12 h-12 flex items-center justify-center text-gray-600 dark:text-gray-400 mr-4">
        {icon}
      </div>
      <div className="flex-1">
        <h3 className="text-base font-medium text-gray-900 dark:text-white">{title}</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>
      </div>
    </div>
  )
}

export const SettingsPage = () => {
  const navigate = useNavigate()

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-semibold text-gray-900 dark:text-white mb-6">Réglages</h1>
      
      <Card className="divide-y divide-gray-200 dark:divide-gray-700">
        <SettingItem
          icon={<CategoriesIcon className="w-6 h-6" />}
          title="Catégories"
          subtitle="Gérer les catégories et sous-catégories"
          onClick={() => navigate('/categories')}
        />
        
        <SettingItem
          icon={<CertifIcon className="w-6 h-6" />}
          title="Certifications et labels"
          subtitle="Gérer les certifications et labels"
          onClick={() => navigate('/certifications')}
        />
        
        <SettingItem
          icon={<BrandIcon className="w-6 h-6" />}
          title="Marques"
          subtitle="Gérer les marques"
          onClick={() => navigate('/brands')}
        />
        
        <SettingItem
          icon={<ContinentsIcon className="w-6 h-6" />}
          title="Continents"
          subtitle="Gérer les continents de fabrication"
          onClick={() => navigate('/continents')}
        />
        
        <SettingItem
          icon={<MessageIcon className="w-6 h-6" />}
          title="Message d&apos;accueil"
          subtitle="Modifier le message de la page de login"
          onClick={() => navigate('/login-message')}
        />
      </Card>
    </div>
  )
}